import { TweenLite } from "gsap";
import { IInterval } from "../../Context/Interval";
import { ISystemContext } from "../../Context/SystemContext";
import { CSSResource } from "../../ResourceManager/CSSResource";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SlotGameInitData, BonusConfigurationList } from "../../SlotGameInitData";
import { Translator } from "../../Translator";
import { Size, Scale, SetStyles, CreateElement } from "../.././MyHelpers";
import { PayTable } from "../Paytable/Paytable";
import { SlotGameMessages } from "../SlotGameScreenMessages";
import { SlotSymbolSprite } from "../SlotSymbolSprite";
import { IGenericSlider } from "./GenericSlider";
import { SecondScreenHelpParams } from "./Slide2/SecondSceenHelp2Slides";
import { Settings } from "../../Settings";
import { Bonus } from "../Bonus/Bonus";
import { PayTableFactory } from "../Paytable/PayTableFactory";
import { IPaytable } from "../Paytable/IPayTable";
import { SlotSymbol } from "../SlotSymbol";
import { IPaytableParams } from "../Paytable/IPayTableFactory";
import { PlusOneFeatureConfiguration } from "../../api";

export class SecondScreenHelp   implements Resourceful,IGenericSlider
{

    protected view:HTMLElement = null;
    protected initData :SlotGameInitData;

    protected resid: ResourceIdentifier;
    protected logGroup: string;
    
    protected helpSlides: HelpSlide[] = [];

    protected gamePath:string  = "";
    protected commonPath:string = "";
    protected commonpath2:string = "";
   
    protected game2path:string = "";
    

    protected features:string[] =[];

    protected slideFactory:SlideFactory = null;

    protected currentSlide:number = 0;

    //protected interval:number = -1;
    protected nextSlideTimer: IInterval;
    
    protected readonly nextSlideInterval:  number = 10 * 1000; //18*1000;
    protected readonly transitionDuration: number = 1000;

    protected translator:Translator;
    protected systemContext: ISystemContext;

    protected paytable: IPaytable = null;
    protected symbolSpriteAnims: SlotSymbolSprite[] = [];
    protected viewSize: Size = null;
    protected availableSymbols: SlotSymbol[] = [];

	


    constructor(params: SecondScreenHelpParams)
    {
        this.systemContext = params.systemContext.CreateSubContext("SecondScreenHelp");
        this.translator = params.translator;
        this.symbolSpriteAnims = params.symbolSpriteAnims;
        this.viewSize = params.viewSize;
        this.availableSymbols = params.availableSymbols;

        this.initData = params.initData;
        this.logGroup = "SecondScreenHelp";
        this.resid = params.resid.Add("SecondScreenHelp");
        this.gamePath = Settings.ResourcesFolder + "multigame/slot/"+ params.gameName + "/resources/";
        this.commonPath = Settings.ResourcesFolder + "multigame/slot/common/secondScreenHelp/";
        this.commonpath2 = Settings.ResourcesFolder + "multigame/slot/common/";
		
        //this.game2path = Settings.ResourcesFolder + "multigame/slot/common/"; 
        //this.slideFactory = factory;
        this.slideFactory = new SlideFactory();
        this.translator = params.translator;
        this.view = document.createElement("div");
        this.view.classList.add("slideShow");
        this.view.style.width = "100%";
        this.view.style.height = Scale.Hpx(671);

        if (this.initData.BonusConfiguration)
        {
            if (this.initData.BonusConfiguration.FreeGameBonus)
            {
                this.features.push("FreeGameBonus");
            }

            if (this.initData.BonusConfiguration.PickBonus)
            {
                this.features.push("ProgressivePickBonus");
                this.features.push("PickBonus");
                this.features.push("Jp");
            }

            // if (this.initData.bonusConfiguration.DiamondSpin)
            // {
            //     this.features.push("DiamondSpin");
            // }
        }


        if(this.initData.Feature.includes("ExpandingWildBulk"))
        {
            this.features.push("ExpandingWildBulk")
        }
        
        else if(this.initData.Feature.includes("ExpandingWildReel"))
        {
            this.features.push("ExpandingWildReel")
        }
        else
        {
            this.features.push("Wild");
        }
        
        for(let i = 0; i < this.features.length; i++)
        {
            this.helpSlides.push(this.slideFactory.CreatSlide(this.features[i],this.initData,this.gamePath,this.resid,this.commonPath, this.slideFactory,this.translator, this.initData.BonusConfiguration));
        }
        
        this.nextSlideTimer = this.systemContext.TimingContext().CreateInterval("nextSlideTimer", this.nextSlideInterval, () => this.NextSlide());
        //this.helpSlides.push(new HelpSlideWildFreeGame(this.initData,this.gamePath,this.resid,this.commonPath));
    }
    RequestPause(): void {
        // nothing to do
    }

    public async PrepareResources(resourceManager: ResourceManager)
    {
        //resourceManager.Add(new HTMLResource(this.game2path + "game2.html", this.resid.ScopedResourceName("html")));
        //resourceManager.Add(new CSSResource(this.game2path + "game.2.css",this.resid.ScopedResourceName("css"), this.resid.CSSScope()));
        this.PaytablePrepare(resourceManager);
        for (let i = 0; i < this.helpSlides.length ; i++) {
			await this.helpSlides[i].PrepareResources(resourceManager);
		}

    }

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager)
    {
        //this.view.innerHTML += resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;
        for (let i = 0; i < this.helpSlides.length ; i++) {	
            await this.helpSlides[i].ResourcesLoaded(resourceManager);
            TweenLite.set(this.helpSlides[i].View(),{x: (i*200)+"%"});
			this.view.appendChild(this.helpSlides[i].View());
        }
        this.SetStyle();
        this.PaytableLoaded(resourceManager);
      
    }


    protected PaytablePrepare(resourceManager: IWriteOnlyResourceManager): void {
		resourceManager.Add(new CSSResource(this.commonpath2 + "resources/paytable.css", this.resid.ScopedResourceName(["paytable", "css"]), this.resid.CSSScope()));
		resourceManager.Add(new ImageResource(this.gamePath + "paytable.png", this.resid.ScopedResourceName(["paytable", "background"])));

        let paytableParams : IPaytableParams ={
			paytable : this.initData.Paytable,
			symbolSpriteAnims : this.symbolSpriteAnims,
			viewSize : this.viewSize,
			symbols : this.availableSymbols,
			nameGame : null,
            resid : this.resid,
            systemContext : this.systemContext,
            initData : this.initData,
            translator : this.translator,
            symbolsCollection : null,
		} 
		this.paytable = new PayTableFactory().CreatePayTable(paytableParams);
        this.paytable.PrepareResources(resourceManager);
		
	}

    
	protected PaytableLoaded(resourceManager: IReadOnlyResourceManager): void {
        this.paytable.ResourcesLoaded(resourceManager);
		let paytableView = this.paytable.View();
        paytableView.style.position = "relative";
        paytableView.style.bottom="-318px";
        
        //paytableView.classList.add("paytable-container");
        paytableView.classList.add(this.resid.Scope());
		
        
		this.view.appendChild(this.paytable.View());
        
		SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
		{
			backgroundImage : resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["paytable", "background"])).CssBackground(),
			borderRadius:"0px",
			
		});
		
		this.paytable.Update(true);
	}

    public SetStyle()
    {
        SetStyles(this.view,
            Object.assign({},
            {
                fontFamily:"NotoSansDisplay-Bold",
                color: "#f5f5f5",
                //textShadow: "1px 1px 1px #919191,1px 2px 1px #919191,3px 1px #919191,1px 4px 1px #919191,1px 5px 1px #919191,1px 6px 1px #919191,1px 7px 1px #919191,1px 8px 1px #919191,1px 9px 1px #919191, 1px 10px 1px #919191, 1px 18px 6px rgba(16,16,16,1), 1px 22px 10px rgba(16,16,16,1), 1px 25px 35px rgba(16,16,16,1),1px 30px 60px rgba(16,16,16,1)",
                //textShadow: "-1px -1px 0px #0074D9,2px 2px 0px #0074D9,4px 4px 0px #001f3f",
                textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
                overflow: "hidden",
            },
            this.slideFactory.CreateStyle()));
    }

    public NextSlide()
    {
        //// Log.Debug(this.logGroup, "Next slide");
        for(let i = 0, c= this.currentSlide ; i < this.helpSlides.length; i++, c = (c+1)%this.helpSlides.length)
        {
            let p = (i-1)*200;
            TweenLite.to(this.helpSlides[c].View(),this.transitionDuration / 1000,{x: p+"%"});

            //// Log.Debug(this.logGroup, "Changing slide " + c + " to " + p + "%");
        }

        let c = this.currentSlide;

        setTimeout(()=>{
            let lastSlidePosition: number = 200* (this.helpSlides.length -1);
            //// Log.Debug(this.logGroup, "Changing leftmost slide " + c + " to " + lastSlidePosition + "%");

            TweenLite.set(this.helpSlides[c].View(),{x: (lastSlidePosition)+"%"});
        }, this.transitionDuration);

        this.currentSlide = (this.currentSlide+1) % this.helpSlides.length;
    }

    protected started = false;

    public Start():void
    {
        if (!this.started)
        {
            this.started = true;
            if(this.helpSlides.length > 2)
            {
                this.nextSlideTimer.Start();
            }
            else
            {
                // no sliding, when only 1 or 2 slides
            }
        }
    }

    public Stop():void
    {
        this.started = false;
        this.nextSlideTimer.Stop();
    }

    public Reset():void
    {
        //this.Start();
    }

    public View():HTMLElement
    {
        return this.view;
    }

    public Hide():void
    {
        this.view.style.visibility = "hidden";
    }

    public Update():void
    {

    }

    public SetBet(message: SlotGameMessages.BetChange)
    {
        this.paytable.SetBet(message);
    }
    public PayTableUpdate(force?:boolean){this.paytable.Update(force)}
}

export class HelpSlide implements Resourceful
{
    protected initData:SlotGameInitData = null;
    protected view: HTMLElement = null;
    protected path: string="";
    protected commonPath: string="";
    protected resid :ResourceIdentifier = null;
    protected translator:Translator;
    



    public constructor(initData: SlotGameInitData , path: string ,resid: ResourceIdentifier, commonpath: string, slideFactory: ISlideStyleFactory, translator: Translator)
	{
        this.initData = initData;
        this.path = path;
        this.resid = resid;
        this.commonPath = commonpath;
        this.translator=translator;
        
		/* this.title = title;
		*/
		this.resid = resid.Add("Slide");
		this.view = document.createElement("div");
		this.view.classList.add("slide"); 


	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {

	}

	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

	}

	public View() :HTMLElement
	{
		return this.view;
	}

}

class ProgressivePickBonus extends HelpSlide
{
    protected override initData: SlotGameInitData;    
    protected override view: HTMLElement;
    protected override path: string;
    protected override commonPath: string;
    protected override resid: ResourceIdentifier;
    protected override translator: Translator;
    protected description: HTMLElement = null;

    protected jp1:HTMLElement = null;
	protected jp2:HTMLElement = null;
	protected jp3:HTMLElement = null;
    protected jp4:HTMLElement = null;

    protected pots: HTMLElement = null;

    public constructor(initData:SlotGameInitData, path:string, resid:ResourceIdentifier, commonPath:string, slideFactory:ISlideStyleFactory,translator:Translator)
    {
        super(initData,path,resid,commonPath,slideFactory,translator);
        this.translator = translator;

        //slide
        this.resid = this.resid.Add("ProgressivePickBonus");
        this.view = document.createElement("div");
        this.view.classList.add("ProgressivePickBonusSlide");
        SetStyles(this.view,
        {
            position:"absolute",
            height:"52%",
            width:"60%",
            display: "flex",
            flexDirection:"column",
            flexShrink:"0",
            left: "490px",
            alignItems: "center",
        });

        // description
        this.description = document.createElement("div");
        this.description.classList.add("progresive-description");
        //this.description.appendChild(this.translator.Anchor(() => this.translator.t.progressivePickBonus));
        SetStyles(this.description,
        {
            height:"100%",
            width:"100%",
            display:"flex",
            fontSize: "55px",
        });
    }
    
    
    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
    {
        resourceManager.Add(new ImageResource(this.commonPath + "sapphire.png", this.resid.ScopedResourceName(["sapphire", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "emerald.png", this.resid.ScopedResourceName(["emerald", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "ruby.png", this.resid.ScopedResourceName(["ruby", "image"])));
        resourceManager.Add(new ImageResource(this.commonPath + "diamond.png", this.resid.ScopedResourceName(["diamond", "image"])));
        resourceManager.Add(new ImageResource(this.commonPath + "pots.png", this.resid.ScopedResourceName(["pots", "image"])));

    }
    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
    {
        this.view.appendChild(this.description); 
        
        this.pots = document.createElement("span");
        this.pots.classList.add("pots");
		SetStyles(this.pots,
		{
			width:"325px",
			height:"100px",
			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pots", "image"])).CssBackground(),
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
			backgroundPosition:"center",
			display: "inline-block",
			verticalAlign: "middle",
        });

        this.jp4 = document.createElement("span");
        this.jp4.classList.add("jp4");
        SetStyles(this.jp4,
        {
            width:"120px",
            height:"120px",
            backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["diamond", "image"])).CssBackground(),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition:"center",
            display: "inline-block",
            verticalAlign: "middle",
        });

        this.jp3 = document.createElement("span");
        this.jp3.classList.add("jp3");
        SetStyles(this.jp3,
        {
            width:"120px",
            height:"120px",
            backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["ruby", "image"])).CssBackground(),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition:"center",
            display: "inline-block",
            verticalAlign: "middle",
        });

        this.jp2 = document.createElement("span");
        this.jp2.classList.add("jp2");
        SetStyles(this.jp2,
        {
            width:"120px",
            height:"120px",
            backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["emerald", "image"])).CssBackground(),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition:"center",
            display: "inline-block",
            verticalAlign: "middle",
        });

        this.jp1 = document.createElement("span");
        this.jp1.classList.add("jp1");
        SetStyles(this.jp1,
        {
            width:"120px",
            height:"120px",
            backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["sapphire", "image"])).CssBackground(),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition:"center",
            display: "inline-block",
            verticalAlign: "middle",
        });

        let translatedMessage = this.translator.Translate(() => this.translator.t.progressivePickBonus(this.jp1.outerHTML,this.jp2.outerHTML,this.jp3.outerHTML,this.jp4.outerHTML,this.pots.outerHTML));
        this.description.appendChild(translatedMessage.location)
        this.view.appendChild(this.description);


    }
    public override View(): HTMLElement {
        return this.view;
    }

}


class FreeGameBonusSlide extends HelpSlide
{
    protected bonusInstruction:HTMLElement = null;
    protected bonusTitle:HTMLElement= null;
    protected bonusTrigger:HTMLElement = null;
    protected bonusTrigger2:HTMLElement = null;
    protected bonusInstruction2:HTMLElement = null;

    protected bonusDescription:HTMLElement = null;
    public override translator:Translator;

    protected maxFreeGames: number = 0;
    
     constructor(initData:SlotGameInitData, path:string, resid:ResourceIdentifier, commonPath:string, slideFactory:ISlideStyleFactory,translator:Translator, params: BonusConfigurationList)
     {
        super(initData,path,resid,commonPath,slideFactory,translator);
        this.translator=translator;

        this.maxFreeGames = (params.FreeGameBonus.FeatureConfigurations.find(f => f.FeatureName == "PlusOneFeature") as PlusOneFeatureConfiguration)?.MaxAdditionalFreegames ?? 0;

        //slide
        this.resid = this.resid.Add("FreeGame");
        this.view = document.createElement("div");
        this.view.classList.add("FreeGameSlide");
        SetStyles(this.view,
        {
            position:"absolute",
            height:"52%",
            width:"50%",
            display: "flex",
            flexDirection:"column",
            flexShrink:"0",
            left: "490px",
        });



        // title
        this.bonusTitle = document.createElement("div");
        this.bonusTitle.classList.add("bonus-title");
        this.bonusTitle.appendChild(this.translator.Anchor(() => this.translator.t.freeGameTitle));

        //this.bonusTitle.setAttribute("id","bonustitle");
        SetStyles(this.bonusTitle,
        {
            height:"30%",
            width:"100%",
            fontSize: "60px",
            textAlign:"center",
        });


        // description
        this.bonusDescription = document.createElement("div");
        this.bonusDescription.classList.add("bonus-description");
        SetStyles(this.bonusDescription,
        {
            height:"70%",
            width:"100%",
            display:"flex",
        });

        //trigger
        this.bonusTrigger = document.createElement("div");
        this.bonusTrigger.classList.add("bonus-trigger");
        SetStyles(this.bonusTrigger,
        {
            height:"100%",
            width:"30%",
            backgroundRepeat:"no-repeat",
            backgroundSize:"contain",
            backgroundPosition: "center",

        });    
        this.bonusTrigger2 = document.createElement("div");
        this.bonusTrigger2.classList.add("bonus-trigger2");
        SetStyles(this.bonusTrigger2,
        {
            height:"100%",
            width:"30%",
            backgroundRepeat:"no-repeat",
            backgroundSize:"contain",
            backgroundPosition: "center",

        });

        //instruction
        this.bonusInstruction = document.createElement("div");
        this.bonusInstruction.classList.add("bonus-instruction");
        this.bonusInstruction.appendChild(this.translator.Anchor(() => this.translator.t.bonusinstru(""+this.maxFreeGames)));
        SetStyles(this.bonusInstruction,
        {
            height:"100%",
            width:"60%",
            display:"flex",
            justifyContent:"left",
            alignItems:"center",
            textAlign:"left",
            fontSize:"40px",
        });
        this.bonusInstruction2 = document.createElement("div");
        this.bonusInstruction2.classList.add("bonus-instruction2");
        this.bonusInstruction2.appendChild(this.translator.Anchor(() => this.translator.t.extrafreegame));
        SetStyles(this.bonusInstruction2,
        {
            height:"100%",
            width:"60%",
            display:"flex",
            justifyContent:"left",
            alignItems:"center",
            textAlign:"left",
            fontSize:"30px",
        });

    }


    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> 
    {
        this.DescriptionPrepare(resourceManager);
	}

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> 
    {
        this.DescriptionLoaded(resourceManager);
	}

    /*************************************************************************
		BONUS - DESCRIPTION
	**************************************************************************/
    
    public DescriptionPrepare(resourceManager: IWriteOnlyResourceManager): void {
		resourceManager.Add(new ImageResource(this.path + "freeGames.png", this.resid.ScopedResourceName(["freeGames", "image"])));	
        resourceManager.Add(new ImageResource(Settings.ResourcesFolder + "multigame/slot/common/resources/FreeGameBonus/resources/plusone.png", this.resid.ScopedResourceName(["plusone", "image"])));    

	}

    public DescriptionLoaded(resourceManager: IReadOnlyResourceManager): void
    {
        this.view.appendChild(this.bonusTitle);
        this.bonusDescription.appendChild(this.bonusTrigger);
        this.bonusDescription.appendChild(this.bonusInstruction);

        this.bonusDescription.appendChild(this.bonusTrigger2);
        this.bonusDescription.appendChild(this.bonusInstruction2);
        this.view.appendChild(this.bonusDescription);

        this.bonusTrigger = this.view.querySelector(".bonus-trigger");		
        this.bonusTrigger.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["freeGames", "image"])).CssBackground();
         this.bonusTrigger2 = this.view.querySelector(".bonus-trigger2");        
        this.bonusTrigger2.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["plusone", "image"])).CssBackground();

    }
    
    public override View():HTMLElement
    {
        return this.view;
    }
}


class WildSlide extends HelpSlide
{

    protected wildTrigger:HTMLElement = null;
    protected wildDescription: HTMLElement = null;
    
    protected wildInstruction:HTMLElement = null;
    protected title:HTMLElement = null;

    constructor(initData:SlotGameInitData, path:string, resid:ResourceIdentifier, commonPath:string, slideFactory:ISlideStyleFactory, translator: Translator)
    {
        super(initData, path, resid, commonPath, slideFactory, translator);

        this.resid = this.resid.Add("Wild");

        this.view = document.createElement("div");
        this.view.classList.add("WildSlide");
        SetStyles(this.view,
        {
            position:"absolute",
            height:"52%",
            width:"50%",
            display: "flex",
            flexDirection:"column",
            flexShrink:"0",
            left: "490px",
        });

        // title
        this.title = document.createElement("div");
        this.title.classList.add("title");
        SetStyles(this.title,
        {
            height:"30%",
            width:"100%",
            fontSize: "60px",
            textAlign:"center",
        })

        // description
        this.wildDescription = document.createElement("div");
        this.wildDescription.classList.add("wild-description");
        SetStyles(this.wildDescription,
        {
            height:"70%",
            width:"100%",
            display:"flex",
        })

        //trigger
        this.wildTrigger = document.createElement("div");
        this.wildTrigger.classList.add("wild-trigger");
        SetStyles(this.wildTrigger,
        {
            height:"100%",
            width:"30%",
            backgroundRepeat:"no-repeat",
            backgroundSize:"contain",
            backgroundPosition: "center",

        })
        this.wildInstruction = document.createElement("div");
        this.wildInstruction.classList.add("wild-instruction");
       
        SetStyles(this.wildInstruction,
        {
            height:"100%",
            width:"70%",
            display:"flex",
            justifyContent:"left",
            alignItems:"center",
            textAlign:"left",
            fontSize:"40px",
        })

       


    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
    {

        this.DescriptionPrepare(resourceManager);
	}

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> 
    {

        this.DescriptionLoaded(resourceManager);
	} 
    
     /*************************************************************************
		FEATURES - DESCRIPTION
	**************************************************************************/
    public DescriptionPrepare(resourceManager: IWriteOnlyResourceManager): void 
    {

		resourceManager.Add(new ImageResource(this.path + "wild.png", this.resid.ScopedResourceName(["wild", "image"])));
	}

   
    public DescriptionLoaded(resourceManager: IReadOnlyResourceManager): void 
    {

        this.view.appendChild(this.title);
        this.wildDescription.appendChild(this.wildTrigger);
        this.wildDescription.appendChild(this.wildInstruction);
        this.view.appendChild(this.wildDescription);


        this.view.style.display = "block";
        this.wildTrigger = this.view.querySelector(".wild-trigger");		
        this.wildTrigger.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["wild", "image"])).CssBackground();
         
       this.Description();
		
    }

    public Description()
    {
        this.title.innerHTML = "WILD";
        this.wildInstruction.appendChild(this.translator.Anchor(() => this.translator.t.wildcommon));
    }

    public override View():HTMLElement
    {
        return this.view;
    } 


}

class ExpandingWildBulkSlide extends WildSlide
{

    constructor(initData:SlotGameInitData, path:string, resid:ResourceIdentifier, commonPath:string, slideFactory:ISlideStyleFactory, translator: Translator)
    {
        super(initData, path, resid, commonPath, slideFactory, translator);

        this.resid = this.resid.Add("Bulk");
         this.wildInstruction = document.createElement("div");
        this.wildInstruction.classList.add("wild-instruction");
        
        SetStyles(this.wildInstruction,
        {
            height:"100%",
            width:"70%",
            display:"flex",
            justifyContent:"left",
            alignItems:"center",
            textAlign:"left",
            fontSize:"40px",
        })
        

    }

    public override DescriptionPrepare(resourceManager:ResourceManager):void
    {
        resourceManager.Add(new ImageResource(this.path + "expandingWild.png", this.resid.ScopedResourceName(["wild", "image"])));
    }
    
    public override Description()
    {
        this.title.innerHTML = "EXPANDING WILD";
        this.wildInstruction.appendChild(this.translator.Anchor(() => this.translator.t.wildBulk));

        /*this.wildInstruction.innerHTML = 
        `EXPANDS OVER ALL
         </br>NEIGHBORIING SYMBOLS
        `; */
    }



}

class ExpandingWildReelSlide extends WildSlide
{

    constructor(initData:SlotGameInitData, path:string, resid:ResourceIdentifier, commonPath:string, slideFactory:ISlideStyleFactory, translator: Translator)
    {
        super(initData,path,resid,commonPath,slideFactory, translator);

        this.resid = this.resid.Add("Reel");
         this.wildInstruction = document.createElement("div");
        this.wildInstruction.classList.add("wild-instruction");
        
        SetStyles(this.wildInstruction,
        {
            height:"100%",
            width:"60%",
            display:"flex",
            justifyContent:"left",
            alignItems:"center",
            textAlign:"left",
            fontSize:"40px",
        })
    }
    public override DescriptionPrepare(resourceManager:ResourceManager):void
    {
        resourceManager.Add(new ImageResource(this.path + "epxandingWildReel.png", this.resid.ScopedResourceName(["wild", "image"])));
    }
    
    

    public override Description()
    {
        this.title.innerHTML = "EXPANDING WILD";
        this.wildInstruction.appendChild(this.translator.Anchor(() => this.translator.t.wildreel));
        /*this.wildInstruction.innerHTML = 
        `EXPANDS OVER 
         </br>ENTIRE REEL
        `; */
    }
}

class JPSlide extends HelpSlide
{
    protected title:HTMLElement = null;
    protected description:HTMLElement = null;
    protected instruction:HTMLElement = null
     protected override translator:Translator;

    protected jp1:HTMLElement = null;
	protected jp2:HTMLElement = null;
	protected jp3:HTMLElement = null;
    protected jp4:HTMLElement = null;
    
    protected pot: HTMLElement = null;

    constructor(initData:SlotGameInitData, path:string, resid:ResourceIdentifier, commonPath:string, slideFactory:ISlideStyleFactory,translator:Translator)
    {
        super(initData,path,resid,commonPath,slideFactory,translator);

        this.resid = this.resid.Add("JP");

        this.view = document.createElement("div");
        this.view.classList.add("JpSlide");

        SetStyles(this.view,
        {
            position:"absolute",
            height:"52%",
            width:"50%",
            display: "flex",
            flexDirection:"column",
            flexShrink:"0",
            left: "490px",

        });

        this.title = document.createElement("div");
        this.title.classList.add("title");
        SetStyles(this.title,
        {
            height:"20%",
            width:"100%",
            fontSize: "60px",
            textAlign:"center",
            position:"relative",
            top:"-10px",
        });

        // description
        this.description = document.createElement("div");
        this.description.classList.add("description");
        SetStyles(this.description,
        {
            height:"80%",
            width:"100%",
            display:"flex",
            position:"relative",
            top:"25px",
        });

        //instruction
        this.instruction = document.createElement("div");
        this.instruction.classList.add("instruction");
        SetStyles(this.instruction,
        {
            height:"90%",
            width:"90%",
            justifyContent:"left",
            alignItems:"left",
            textAlign:"left",
            fontSize:"36px",
            lineHeight:"25px",
        });




    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> 
    {
        resourceManager.Add(new ImageResource(this.commonPath + "sapphire.png", this.resid.ScopedResourceName(["sapphire", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "emerald.png", this.resid.ScopedResourceName(["emerald", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "ruby.png", this.resid.ScopedResourceName(["ruby", "image"])));
        resourceManager.Add(new ImageResource(this.commonPath + "diamond.png", this.resid.ScopedResourceName(["diamond", "image"])));
        resourceManager.Add(new ImageResource(this.commonPath + "pot.png", this.resid.ScopedResourceName(["pot", "image"])));

	}

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> 
    {


        this.pot = document.createElement("span");
        this.pot.classList.add("diamondPot");
		SetStyles(this.pot,
		{
			width:"340px",
			height:"105px",
			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pot", "image"])).CssBackground(),
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
			backgroundPosition:"center",
			display: "inline-block",
			verticalAlign: "middle",
        });
        

        this.jp4 = document.createElement("span");
        this.jp4.classList.add("jp4");
        SetStyles(this.jp4,
        {
            width:"55px",
            height:"55px",
            backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["diamond", "image"])).CssBackground(),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition:"center",
            display: "inline-block",
            verticalAlign: "middle",
        });

        this.jp3 = document.createElement("span");
        this.jp3.classList.add("jp3");
        SetStyles(this.jp3,
        {
            width:"55px",
            height:"55px",
            backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["ruby", "image"])).CssBackground(),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition:"center",
            display: "inline-block",
            verticalAlign: "middle",
        });

        this.jp2 = document.createElement("span");
        this.jp2.classList.add("jp2");
        SetStyles(this.jp2,
        {
            width:"55px",
            height:"55px",
            backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["emerald", "image"])).CssBackground(),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition:"center",
            display: "inline-block",
            verticalAlign: "middle",
        });

        this.jp1 = document.createElement("span");
        this.jp1.classList.add("jp1");
        SetStyles(this.jp1,
        {
            width:"55px",
            height:"55px",
            backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["sapphire", "image"])).CssBackground(),
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition:"center",
            display: "inline-block",
            verticalAlign: "middle",
        });

        this.Description();

        this.view.appendChild(this.title);
        this.description.appendChild(this.instruction);
        this.view.appendChild(this.description);
         let translatedMessage = this.translator.Translate(() => this.translator.t.rulediamons(this.jp3.outerHTML,this.jp2.outerHTML,this.jp1.outerHTML,this.jp4.outerHTML,this.pot.outerHTML));
           
            this.View().querySelector(".instruction").appendChild(translatedMessage.location);

       

    }
    
    public Description()
    {
        this.title.innerHTML = "DIAMOND POT JACKPOT";
        /*this.instruction.innerHTML = 
        `4&nbsp;<span class="jp4"></span>&nbsp;win &nbsp;<span class="diamondPot"></span></br>
        4&nbsp;<span class="jp3"></span>&nbsp;win RUBY</br>
        4&nbsp;<span class="jp2"></span>&nbsp;win EMERALD</br>
        4&nbsp;<span class="jp1"></span>&nbsp;win SAPHIRE</br>
        `;

        this.instruction.querySelector(".jp4").appendChild(this.jp4);
        this.instruction.querySelector(".jp3").appendChild(this.jp3);
        this.instruction.querySelector(".jp2").appendChild(this.jp2);
        this.instruction.querySelector(".jp1").appendChild(this.jp1);
        this.instruction.querySelector(".diamondPot").appendChild(this.pot);*/
    }
    
    public override View():HTMLElement
    {
        return this.view;
    }
}


class PickBonusSlide extends HelpSlide
{

    protected diamond:NodeListOf<Element> = null;
    protected title:HTMLElement = null;
    protected description:HTMLElement = null;
    protected instruction:HTMLElement = null;
    protected diamo:HTMLElement=null;
    protected override translator:Translator;
    protected csspath:string = Settings.ResourcesFolder + "multigame/secondscreenhelp/";


    
    constructor(initData:SlotGameInitData, path:string, resid:ResourceIdentifier, commonPath:string, slideFactory:ISlideStyleFactory,translator:Translator)
    {
        
        super(initData,path,resid,commonPath,slideFactory,translator);
        this.translator=translator;

        this.resid = this.resid.Add("PickBonus");

        this.view = document.createElement("div");
        this.view.classList.add("PickBonus");
        this.view.classList.add(this.resid.Scope());

        SetStyles(this.view,
        {
            height:"52%",
            position:"absolute",
            width:"70%",
            display: "flex",
            flexDirection:"column",
            flexShrink:"0",
            left: "490px",
        });

                

        this.title = document.createElement("div");
        this.title.classList.add("title");
        SetStyles(this.title,
        {
            height:"20%",
            width:"70%",
            fontSize: "60px",
            textAlign:"center",
            position:"relative",
            top:"-10px",
        });

        // description
        this.description = document.createElement("div");
        this.description.classList.add("description");
        SetStyles(this.description,
        {
            height:"80%",
            width:"100%",
            display:"flex",
            position:"relative",
            top:"15px",
        });

        //instruction
        this.instruction = document.createElement("div");
        this.instruction.classList.add("instruction");
        SetStyles(this.instruction,
        {
            height:"100%",
            width:"100%",
            justifyContent:"left",
            alignItems:"left",
            textAlign:"left",
            fontSize:"36px",
            lineHeight:"1",
        });



        



    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> 
    {
        resourceManager.Add(new ImageResource(this.commonPath + "trigger.png", this.resid.ScopedResourceName(["trigger", "image"])));
        //resourceManager.Add(new CSSResource(this.csspath + "secondScreenHelp.css",this.resid.ScopedResourceName(["PickBonus","css"]),this.resid.CSSScope()));
	}

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> 
    {
        this.Description();

        this.diamo = document.createElement("span");
		
			SetStyles(this.diamo,
			{
				width:"70px",
				height:"70px",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["trigger", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition:"center",
				display: "inline-block",
				verticalAlign: "middle",
			});
        

        this.view.appendChild(this.title);
        this.description.appendChild(this.instruction);
        this.view.appendChild(this.description);

        let translatedMessage = this.translator.Translate(() => this.translator.t.rulediamon(this.diamo.outerHTML));
           
            this.View().querySelector(".instruction").appendChild(translatedMessage.location);
            
            
    }
    
    public Description()
    {
        this.title.innerHTML = "DIAMOND POT BONUS";
        /*this.instruction.innerHTML = 
        `3&nbsp;<span class="trigger"></span>&nbsp;OR MORE ANYWHERE OPENS THE DIAMOND</br>      POT BONUS AND PAYS 5X BET</br>
        4&nbsp;<span class="trigger"></span>&nbsp;ANYWHERE PAYS 10X BET</br>
        5&nbsp;<span class="trigger"></span>&nbsp;ANYWHERE PAYS 50X BET</br>
        `;*/



    }
    
    public override View():HTMLElement
    {
        return this.view;
    }

}

class DiamondSpinSlide extends HelpSlide
{
    protected title:HTMLElement = null;
    protected precoiusSpininstruction: HTMLElement = null;
    protected trigger: HTMLElement = null;

    protected diamondSpinPath:string = Settings.ResourcesFolder + "multigame/slot/common/resources/DiamondSpin/";

    constructor(initData:SlotGameInitData, path:string, resid:ResourceIdentifier, commonPath:string, slideFactory:ISlideStyleFactory,translator:Translator)
    {
        super(initData,path,resid,commonPath,slideFactory,translator);


        this.view = CreateElement("div", {classes:["DiamondSpinSlide"], 
            style:
            {
                position:"absolute",
                height:"100%",
                width:"50%",
                display: "flex",
                flexDirection:"column",
                flexShrink:"0",
                left: "490px",
            }
        });

        this.title = CreateElement("div", {classes:["title"], parentToAppend: this.view,
            style:
            {
                height:"20%",
                width:"100%",
                fontSize: "60px",
                textAlign:"center",
                position:"relative",
                top:"-10px",
            }
        });

        this.precoiusSpininstruction = CreateElement("div", {classes:["precoiusSpininstruction"],
            style:
            {
                height:"80%",
                width:"100%",
                display:"flex",
                justifyContent:"left",
                alignItems:"center",
                textAlign:"left",
                fontSize:"40px",
            }
        });
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
    {
        resourceManager.Add(new ImageResource(this.diamondSpinPath + "trigger.png", this.resid.ScopedResourceName(["trigger", "image"])));
    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
    {
        this.trigger = CreateElement("span", {classes:["trigger"],
            style:
            {
                height:"80px",
                width:"100px",
                backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["trigger", "image"])).CssBackground(),
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition:"center",
                display: "inline-block",
                verticalAlign: "middle",
            }
        })
        this.Description();
    }

    public Description()
    {
        this.title.innerHTML = "PRECIOUS SPIN BONUS";

        this.precoiusSpininstruction.appendChild(this.translator.Anchor(() => this.translator.t.diamondSpinSecondScreenHelp(this.trigger.outerHTML)));

        this.view.appendChild(this.precoiusSpininstruction);
    }

    public override View():HTMLElement
    {
        return this.view;
    }
}



export interface ISlideFactory
{
    CreatSlide(feature: string, initData: SlotGameInitData, path: string, resid: ResourceIdentifier, commonPath: string, slideFactory: ISlideStyleFactory, translator: Translator, params: BonusConfigurationList): HelpSlide;
}

export interface ISlideStyleFactory
{
    CreateStyle(): Partial<CSSStyleDeclaration>;
}

export class SlideFactory implements ISlideFactory, ISlideStyleFactory
{
	public CreatSlide(feature: string,initData:SlotGameInitData, path:string, resid:ResourceIdentifier, commonPath:string, slideFactory:ISlideStyleFactory,translator:Translator, params: BonusConfigurationList): HelpSlide 
	{
        switch(feature)
        {
            case "FreeGameBonus":
            {
                return new FreeGameBonusSlide(initData, path, resid, commonPath,slideFactory, translator, params);
            }
            case "Wild":
            {
                return new WildSlide(initData, path, resid, commonPath,slideFactory, translator);
            }
            case "ExpandingWildBulk":
            {
                return new ExpandingWildBulkSlide(initData, path, resid, commonPath, slideFactory, translator);
            }
            case "ExpandingWildReel":
            {
                return new ExpandingWildReelSlide(initData, path, resid, commonPath, slideFactory, translator);
            }
            case "Jp":
            {
                return new JPSlide(initData, path, resid, commonPath,slideFactory, translator);
            }
            case "PickBonus":
            {
                return new PickBonusSlide(initData, path, resid, commonPath,slideFactory, translator);
            }
            case "ProgressivePickBonus":
            {
                return new ProgressivePickBonus(initData, path, resid, commonPath,slideFactory, translator);
            }
            case "DiamondSpin":
            {
                return new DiamondSpinSlide(initData, path, resid, commonPath,slideFactory, translator);
            }
           
            default:
                return null;
        }


    }

    public CreateStyle():Partial<CSSStyleDeclaration>
    {
        let style :Partial<CSSStyleDeclaration> = 
        {
        };
        
        return style;
    }
}

